import { takeLatest } from 'redux-saga/effects'
import { SHOW_AUCTION_CONTRACT_MODAL, SHOW_BUY_NOW_MODAL } from 'dealer-reducers'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* ShowModalFlow(): Generator<any, void, any> {
  try {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    yield window.scrollTo({ behavior: 'smooth', top: 0 })
    yield (document.body.style.overflow = 'hidden')
  } catch (error) {}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* ShowModal(): Generator<any, void, any> {
  yield takeLatest([SHOW_BUY_NOW_MODAL, SHOW_AUCTION_CONTRACT_MODAL], ShowModalFlow)
}
